// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgy_a bhv_bi"};